import Immutable, { Map } from 'immutable';
import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';
import Trip from '../records/Trip';

class TripsStore extends BaseStore {

    deserialize (serialized) {
        if (serialized) {
            return Immutable.fromJS(serialized).map((trip) => Trip.fromJSON(trip.toJS()));
        }
        return new Map();
    }

    handleOrderTripCreated ({ trip, orderTrip }) {
        this.setState(this.state.set(orderTrip.id, trip));
    }

    handleOrderTripDeleted ({ orderTrip }) {
        this.setState(this.state.delete(orderTrip.id));
    }

    handleOrderCreated ({ trip, order }) {
        const orderTrip = order.trips.first();
        this.handleOrderTripCreated({ trip, orderTrip });
    }

    handleClear () {
        this.setState(new Map());
    }

    isSmartCard () {
        return this.state.size && this.state.first().isSmartcard();
    }

    getActionHandlers () {
        return {
            [ActionTypes.ORDER_TRIP_CREATED]: this.handleOrderTripCreated,
            [ActionTypes.ORDER_TRIP_DELETED]: this.handleOrderTripDeleted,
            [ActionTypes.ORDER_CREATED]: this.handleOrderCreated,
            [ActionTypes.ORDER_PLUSBUS_UPDATED]: this.handleOrderTripCreated,
            [ActionTypes.ORDER_PAID]: this.handleClear,
            [ActionTypes.BASKET_CLEARED]: this.handleClear,
            [ActionTypes.LOGGED_OUT]: this.handleClear
        };
    }

}

const instance = new TripsStore({ storageKey: 'trips' });



export default instance;
